<template>
  <div class="products-hghg-page-content flex flex-col items-center w-full text-left">
    <section class="relative w-full flex flex-col items-center max-ml:hidden">
      <Pic class="w-full relative z-0 min-h-20rem max-ml:w-100% max-ml:object-cover max-ml:object-center"
        :src="content.banner" alt="" />
      <PageContentCenter class="text-[#616671] absolute top-[136px]">
        <h2 class="text-42.08px text-[#102136] mb-[2rem] font-semibold">
          {{ title }}
        </h2>
        <p class="">{{ description }}</p>
      </PageContentCenter>
    </section>

    <section class="ml:hidden w-full">
      <Pic class="w-full" src="/images/mobile/products/hghg.png"></Pic>
    </section>

    <section class="relative w-full text-left">
      <PageContentCenter>
        <h2 class="text-[2rem] text-[#272E3B] pt-[80px] mb-2.19rem font-bold">
          {{ content.businessIntroduction.title }}
          <span class="font-thin text-[#C2CDE5] text-1.63rem titleLine max-ml:hidden">BUSINESS</span>
        </h2>
      </PageContentCenter>

      <PageContentCenter class="text-[#616671] text-[1rem] relative pb-9.8rem max-ml:pb-1rem">
        <div class="relative flex flex-col">
          <div class="relative mb-[4rem]">
            <h3 class="relative  mb-1.14rem hghg-business-introduction-title">
              <span class="relative z-2">{{ content.businessIntroduction.subTitle }}</span>
            </h3>

            <ul class="features-group-ul">
              <li v-for="desc in content.businessIntroduction.descList"
                class="text-[#616671] text-[1rem] mb-[1.13rem] features-group-li">{{ desc
                }}
              </li>
            </ul>
          </div>
          <Pic :src="content.businessIntroduction.descImage" class="w-[80rem] self-center max-ml:hidden"></Pic>
        </div>
      </PageContentCenter>
    </section>

    <section class="w-full ">
      <h2 class="text-[2rem] text-[#272E3B] pt-[80px] font-bold max-ml:pt-[2rem]">
        <PageContentCenter>
          {{ content.featuresIntroduction.title }}
          <span class="font-thin text-[#C2CDE5] text-1.63rem titleLine max-ml:hidden">FUNCTION</span>
        </PageContentCenter>
      </h2>

      <section
        :class="['py-3.56rem', group.direction === 'copywriting-to-image' ? '' : 'bg-[linear-gradient(180deg,#FBFDFF_0%,#F9FCFF_100%)]']"
        v-for="group in content.featuresIntroduction.groups">
        <PageContentCenter
          :class="['flex', 'justify-center', 'gap-160px', 'relative', group.direction === 'image-to-copywriting' ? 'ml:flex-row-reverse' : '', 'max-ml:flex-col!', 'max-ml:gap-20px']">
          <div class="w-350px relative align-self-center max-lg:w-100%">
            <div :class="['mb-1.75rem']">
              <Pic :src="group.icon" class="w-[5.5rem] h-[5rem] mb-1.75rem max-ml:hidden"></Pic>
              <h4 class="text-1.88rem">{{ group.title }}</h4>
            </div>
            <ul class="features-group-ul">
              <li v-for="desc in group.descList" class="text-[#616671] text-[1rem] mb-[2rem] features-group-li">{{
                desc
                }}
              </li>
            </ul>
          </div>
          <Pic class="w-42.25rem max-ml:w-100%" :src="group.mainImage" :style="{}"></Pic>
        </PageContentCenter>
      </section>
    </section>

    <section class="relative w-full hghg-product-advantage h-58.13rem  max-ml:h-[auto] ">
      <PageContentCenter class="text-[#272E3B] relative max-ml:w-100%">
        <h2 class="text-42.08px text-[#fff] pt-[80px] text-left mb-7.38rem max-ml:mb-[3rem] ">
          {{ content.advantage.title }}
          <span class="font-thin text-[#C2CDE5] text-1.63rem titleLine max-ml:hidden">ADVANTAGE</span>
        </h2>
        <ul class="flex justify-center gap-2.44rem max-ml:flex-col max-ml:items-center max-ml:gap-0px">
          <li v-for="item in content.advantage.list"
            class="hghg-product-advantage-item relative max-ml:!w-100% relative max-ml:mb-20px">
            <Pic :src="item.icon" class="relative h-16.5rem  max-ml:h-auto"></Pic>
            <h5 class="text-center text-1.88rem text-#080649 font-semibold mt-2rem mb-1.5rem title">{{ item.title }}
            </h5>
            <p class="text-center text-[#95A6BF] text-1rem px-2.38rem mb-3.8rem leading-2rem">{{
              item.desc }}</p>
          </li>
        </ul>
      </PageContentCenter>
    </section>

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '和贵惠供'
const description = '和贵惠供商城,是一款专为便利店、餐饮店、母婴店等线下终端门店打造的微信小程序批发平台'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  banner: '/images/pages/products/hghg/banner@2x.png',
  businessIntroduction: {
    title: '产品业务介绍',
    // 副标题
    subTitle: '和贵惠供商城,是一款专为便利店、餐饮店、母婴店等线下终端门店打造的微信小程序批发平台',
    desc: '',
    mainImage: '/images/pages/products/hghg/Frame 427321214@2x.png',
    descList: [
      '我们深谙门店经营痛点,旨在通过数字化革新,打造更高效、更经济的进货体验',
      '平台以"一站式采购"与"源头价直供"为核心价值,整合海量优质供应商,全面覆盖门店日常所需品类',
      '所有商品均由平台甄选,价格透明,全面拉动价格优势,切实助力门店显著降低采购成本'
    ],
    descImage: '/images/pages/products/hghg/Frame 2147229756@2x.png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    groups: [
      {
        title: '用户采购平台',
        desc: '',
        descList: [
          '终端门店采购平台,支持多种下单模式,涵盖积分、现金、余额多种方式组合下单',
          '搭建不同营销活动和手段，促进用户下单 ',
        ],
        icon: '/images/pages/products/hghg/Frame 2147229480@2x(1).png',
        mainImage: '/images/pages/products/hghg/hghg-t- (3).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '商家管理终端',
        desc: '',
        descList: ['独立商家管理终端,商家自主调控商品价格、库存、店铺装修,实时跟进订单数据完成履约',],
        icon: '/images/pages/products/hghg/Frame 427321420@2x.png',
        mainImage: '/images/pages/products/hghg/Frame 2147229646@2x(1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '营销中心',
        desc: '',
        descList: ['搭建多种营销活动，如秒杀、团购、优惠券、夺宝等', '海量玩法促进用户活跃及产品销售'],
        icon: '/images/pages/products/hghg/Frame 2147229355@2x(1).png',
        mainImage: '/images/pages/products/hghg/hghg-t- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '订单中心',
        desc: '',
        descList: ['多端口同步生成订单、售后单，平台保障用户下单流程安全，商家快速履约、售后、交易有保障',],
        icon: '/images/pages/products/hghg/Frame 2147229478@2x.png',
        mainImage: '/images/pages/products/hghg/Frame 2147229646@2x(3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '用户中心',
        desc: '',
        descList: ['搭建用户池,构建用户标签,用户精准分类，助力平台精准营销',],
        icon: '/images/pages/products/hghg/Frame 2147229480@2x(2).png',
        mainImage: '/images/pages/products/hghg/hghg-t- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '数据中心',
        desc: '',
        descList: ['实时交易数据、用户数据、营销活动数据、访问数据统计，多维度报表，为平台及商家运营提供数据依据',],
        icon: '/images/pages/products/hghg/Frame 427321420@2x.png',
        mainImage: '/images/pages/products/hghg/Frame 2147229646@2x(4).png',
        direction: 'image-to-copywriting'
      }, {
        title: '财务中心',
        desc: '',
        descList: ['实时交易流水，月度、年度账单,不同币种结算模型，综合性统计、结算、票据管理中心',],
        icon: '/images/pages/products/hghg/Sales-report@2x.png',
        mainImage: '/images/pages/products/hghg/Frame 2147229651@2x.png',
        direction: 'copywriting-to-image'
      }, {
        title: '商品中心',
        desc: '',
        descList: ['多端协同,商品精细分类，品牌授权正品保障', '实时维护商品销售数据、库存数据，保障信息准确性'],
        icon: '/images/pages/products/hghg/Frame 2147229355@2x(4).png',
        mainImage: '/images/pages/products/hghg/Frame 2147229721@2x.png',
        direction: 'image-to-copywriting'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    list: [
      {
        title: '极简采购',
        desc: '通过全流程数字化工具，为门店提供高性价比的正品货源与高效稳定的履约服务，大幅简化采购流程，提升进货效率与确定性',
        icon: '/images/pages/products/hghg/Frame 2147229852@2x.png',
      },
      {
        title: '一体化供应链',
        desc: '平台构建覆盖选品、下单、配送及售后全链路的整合供应链体系，确保各环节无缝衔接，切实帮助门店实现降本增效与稳健经营',
        briefBack: '/images/pages/products/hghg/Group 1171274812@2x.png',
        icon: '/images/pages/products/hghg/Frame 2147229853@2x.png',
      },
      {
        title: '双核驱动',
        desc: '商家会员中心与和贵惠供商城协同运作，深度融合用户运营与业务场景，双向赋能，共同构建连接用户与业务的可持续增长新生态',
        icon: '/images/pages/products/hghg/Frame 2147229852@2x (1).png',
      }
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-hghg-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .titleLine {
    position: relative;
    padding-left: 30px;

    &::before {
      position: absolute;
      top: 50%;
      left: 12px;
      width: 2px;
      height: 18px;
      margin-top: -7px;
      background-color: #c2cde5;
      content: "";
    }
  }

  .hghg-product-advantage-item {
    width: 28.63rem;
    height: auto;
    border-radius: 1.25rem;
    background: linear-gradient(180deg, #ebf5ff 0%, #fdfeff 51%, #e5f6ff 100%);
    text-align: center;

    .hghg-product-advantage-item-brief {
      width: 100%;
      height: 5.56rem;
      border-radius: 0 0 1.25rem 1.25rem;
      background-size: cover;
      color: #fff;
      font-size: 1.5rem;
      font-weight: bold;
      line-height: 5.56rem;
      text-align: center;
    }

    .title {
      position: relative;

      &::after {
        position: absolute;
        bottom: -10px;
        left: 50%;
        width: 132px;
        height: 29px;
        margin-left: -66px;
        background-image: url("/images/pages/products/hghg/HEGUIKEJI@2x.png");
        background-size: cover;
        content: "";
      }
    }
  }

  .hghg-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/hghg/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/hghg/cercel.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.hghg-product-advantage {
  background-image: url("/images/pages/products/hghg/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
